import NextHead from "next/head"

import { siteConfig } from "@/config/site"

import { useHasPageTitle } from "@/components/shared/BrowserTabTitle"

export const Head = () => {
  const hasPageTitle = useHasPageTitle()

  return (
    <NextHead>
      {hasPageTitle ? null : <title>{siteConfig.name}</title>}
      {hasPageTitle ? null : (
        <meta key="og:title" content={siteConfig.name} property="og:title" />
      )}
      <meta content={siteConfig.description} property="og:description" />
      <meta content={siteConfig.description} name="description" />
      <meta
        key="viewport"
        content="viewport-fit=cover, width=device-width, initial-scale=1.0"
        name="viewport"
      />
    </NextHead>
  )
}
